import React from 'react'
import { Col, DatePicker, Form, Input, Row } from 'antd'
import { get } from 'lodash'
import { defaultFormItemLayout, fullWidthFormItemLayout, rules } from '../../../modules/FormItems'
import { dateVal } from '../../../modules/Utils'
import { compose } from 'recompose'
import withSort from '../../../elements/HOC/withSort'
import CustomSelect from '../../../elements/Select/CustomSelect'
import EmployeeSelect from '../../../elements/Select/Employee/EmployeesSelect'
import withSelectFetch from '../../../elements/Select/withSelectFetch'
import withSpinning from '../../../elements/HOC/withSpinning'
import withKeyValue from '../../../elements/HOC/WithKeyValue'

const { RangePicker } = DatePicker
const { TextArea } = Input
const StatusSelect = compose(
  withSelectFetch({ dropdown: 'devices', name: 'status' }),
  withSpinning,
  withSort
)(CustomSelect)
const TypeSelect = compose(
  withSelectFetch({ dropdown: 'devices', name: 'type' }),
  withSpinning,
  withKeyValue(),
  withSort
)(CustomSelect)

function DevicesForm(props) {
  const { getFieldDecorator, getFieldValue } = props.form
  const { device } = props
  return (
    <Form>
      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'Name'}>
            {getFieldDecorator('name', {
              initialValue: get(device, 'name'),
              rules: rules.input,
            })(<Input placeholder={'Name'} />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'Serial'}>
            {getFieldDecorator('serial', {
              initialValue: get(device, 'serial'),
              rules: rules.input,
            })(<Input placeholder={'Serial'} />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'Type'}>
            {getFieldDecorator('type', {
              initialValue: get(device, 'type'),
              rules: rules.select,
            })(<TypeSelect />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'Registration Date'}>
            {getFieldDecorator('date', {
              initialValue: dateVal(device, 'date'),
            })(<DatePicker style={{ width: '100%' }} placeholder={'Registration Date'} />)}
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item {...fullWidthFormItemLayout} label={'Device Description'}>
            {getFieldDecorator('description', {
              initialValue: get(device, 'description'),
            })(<TextArea placeholder={'Device Description'} />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'Status'}>
            {getFieldDecorator('status', {
              initialValue: get(device, 'status') || 'Active',
              rules: rules.select,
            })(<StatusSelect placeholder={'Status'} />)}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <h3>Assignment</h3>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'Assigned To'}>
            {getFieldDecorator('assignment.to._id', {
              initialValue: get(device, 'assignment.to._id'),
            })(<EmployeeSelect placeholder={'Assigned To'} />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'Assignment Date'}>
            {getFieldDecorator('assignment.date', {
              initialValue: dateVal(device, 'assignment.date'),
              rules: getFieldValue('assignment.to._id') && rules.select,
            })(<DatePicker style={{ width: '100%' }} placeholder={'Assignment Date'} />)}
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item {...fullWidthFormItemLayout} label={'Assignment Description'}>
            {getFieldDecorator('assignment.description', {
              initialValue: get(device, 'assignment.description'),
            })(<TextArea placeholder={'Assignment Description'} />)}
          </Form.Item>
        </Col>
      </Row>
    </Form>
  )
}

DevicesForm.propTypes = {}
DevicesForm.defaultProps = {}

export default Form.create()(DevicesForm)
